module.exports = __webpack_public_path__ + "img/pr-28.f52982c1.png";